import { Pipe, PipeTransform } from '@angular/core';

import { Location } from '../locations/location.model';

@Pipe({
  name: 'locationOrgFilter'
})
export class LocationOrgFilterPipe implements PipeTransform {

  transform(locations: Location[], org_id: number): Location[] {
    return locations.filter((location) => location.org_id == org_id);
  }

}
